import queryString from 'query-string';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import { useMutationAuthChangeEmailConfirm } from 'gql/mutations/auth';
import history from 'lib/history';
import { reportError } from 'lib/tracking';

import ChangeEmailConfirm from './ChangeEmailConfirm';

const ChangeEmailConfirmContainer = () => {
  const { t } = useTranslation();
  const { pathname, search } = useLocation();
  const query = queryString.parse(search);
  const mutationAuthChangeEmailConfirm = useMutationAuthChangeEmailConfirm('/');
  const [hasError, setError] = useState(false);
  useEffect(() => {
    (async function asyncEffect() {
      try {
        if (!query.wantedEmailToken) {
          history.replace('/');
        } else {
          history.replace(pathname);
          await mutationAuthChangeEmailConfirm({
            wantedEmailToken: query.wantedEmailToken,
          });
        }
      } catch (err) {
        setError(true);
        reportError('auth', 'change-email-confirm', err);
      }
    })();
  }, [mutationAuthChangeEmailConfirm, pathname, query]);
  return <ChangeEmailConfirm hasError={hasError} t={t} />;
};

export default ChangeEmailConfirmContainer;
